// src/components/CardComponent.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "../trending.css";

function Currentaffairscard({ news }) {
  const navigate = useNavigate();

 

    const handleClick = () => {

    if (news.id) {
       navigate(`/currentaffairs/${news.id}`);
    }
  };

  return (
    <div className="news-card-cf"   onClick={handleClick}>
      {news.images && news.images.length > 0 && news.images[0].image_url ? (
        <>
          <img
            src={news.images[0].image_url.split('\n')[0]}
            alt={news.topic}
            className="news-image"
            onError={(e) => {
              e.target.onerror = null; // prevent looping
              e.target.src = '/assets/images/noimage.jpeg'//path to your fallback image
            }}
          />
          <div className="news-content">
            <p className="news-title">{news.topic ? news.topic.substring(0, 40) + "..." : ""}</p>
         
          </div>
        </>
      ) : (
         <>
          <img
            src='/assets/images/noimage.jpeg'
            alt={news.topic}
            className="news-image"
          />
          <div className="news-content">
            <p className="news-title">{news.topic ? news.topic.substring(0, 40) + "..." : ""}</p>
          </div>
        </>
     
      )}
    </div>
  );
}

export default Currentaffairscard;
